import { rateTable as mobilityDefaultRateTable } from "../../cvt/data/rateTable";
export const ZONES = ["1", "2", "3", "4", "3bis"];
export const PACKAGES = ["Base", "Medium", "Collisione", "Kasko"];
export const DURATIONS = [12, 24, 36, 48, 60];
export const RATE_DIVISOR = 1000;

const STORAGE_KEY = "dealer_admin_rates_v1";

export const buildDefaultRateTable = () => {
  return JSON.parse(JSON.stringify(mobilityDefaultRateTable));
};

const sanitizeRateTable = (candidate) => {
  if (!candidate || typeof candidate !== "object") {
    return null;
  }

  const sanitized = {};

  for (const zone of ZONES) {
    sanitized[zone] = {};

    for (const pkg of PACKAGES) {
      sanitized[zone][pkg] = {};

      for (const duration of DURATIONS) {
        const raw = candidate?.[zone]?.[pkg]?.[duration];
        const numeric = Number(raw);

        if (!Number.isFinite(numeric)) {
          return null;
        }

        sanitized[zone][pkg][duration] = Number(numeric.toFixed(2));
      }
    }
  }

  return sanitized;
};

export const getStoredRateTable = () => {
  if (typeof window === "undefined") {
    return buildDefaultRateTable();
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return buildDefaultRateTable();
    }

    const parsed = JSON.parse(raw);
    const sanitized = sanitizeRateTable(parsed);

    return sanitized || buildDefaultRateTable();
  } catch (error) {
    return buildDefaultRateTable();
  }
};

export const saveRateTable = (table) => {
  if (typeof window === "undefined") {
    return false;
  }

  const sanitized = sanitizeRateTable(table);

  if (!sanitized) {
    return false;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(sanitized));
    return true;
  } catch (error) {
    return false;
  }
};
